import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { ILedgerHistoryQuery } from './query.types'
import { ILedgerOperationKind, ILedgerOperationsPage, ILedgerWalletOption } from './response.types'

export const getLedgerWallets = (merchantId: number) =>
  axios.get<ApiResponse<ILedgerWalletOption[]>>(
    `${API_URL}/api/internal/merchant/${merchantId}/ledger-wallets`
  )

export const getLedgerOperationKinds = () =>
  axios.get<ApiResponse<ILedgerOperationKind[]>>(
    `${API_URL}/api/internal/merchant/ledger-operation-kinds`
  )

export const getLedgerOperations = (merchantId: number, params: ILedgerHistoryQuery) =>
  axios.get<ApiResponse<ILedgerOperationsPage>>(
    `${API_URL}/api/internal/merchant/${merchantId}/ledger-operations`,
    { params }
  )

export const exportLedgerOperations = (merchantId: number, params: ILedgerHistoryQuery) =>
  axios.get(`${API_URL}/api/internal/merchant/${merchantId}/ledger-operations`, {
    params: { ...params, xlsx: true },
    responseType: 'blob',
  })
